export default __webpack_public_path__ + "static/media/node.9b464a9a.svg";